import { TimeProgramSiteStatus } from '@tempus/trials-types';
import { createAsyncSaga } from 'create-async-saga';
import { call, select, takeEvery } from 'redux-saga/effects';

import { formatBiomarkerOptions } from './biomarkers.utils';
import { BIOMARKER } from './constants';
import { TRIAL_SEARCH_VALUESETS } from '~/routes/trialsPage/trialSearch/constants';
import { formatAggregateValuesetOptions } from '~/routes/trialsPage/trialSearch/utils';
import Api from '~/store/api';
import { SelectOption, TrialSearchQuery, TrialSearchResult } from '~/store/trialSearch/state';

export const getTrialMatches = createAsyncSaga(
  'trialSearch/getTrialMatches',
  function* (payload: { searchParams: TrialSearchQuery; siteId: string | null; statuses: TimeProgramSiteStatus[] }) {
    return yield call(async ({ searchParams, siteId, statuses }): Promise<TrialSearchResult[]> => {
      const response = await Api.trialMatches.getTrialMatches(searchParams, siteId, statuses);
      return response.data;
    }, payload);
  },
);

const getDropdownKeys = () => [...TRIAL_SEARCH_VALUESETS, BIOMARKER];

const hasLoadedDropdowns = (dropdowns: Record<string, SelectOption[]>) =>
  getDropdownKeys().every((key) => Object.prototype.hasOwnProperty.call(dropdowns, key));

export const loadDropdowns = createAsyncSaga(
  'trialSearch/loadDropdowns',
  function* () {
    return yield call(async (): Promise<Record<string, SelectOption[]>> => {
      const { getAllValueSets, getBiomarkers } = Api.dropdowns;
      const [allValueSets, biomarkers] = await Promise.all([getAllValueSets(), getBiomarkers('')]);

      return {
        ...formatAggregateValuesetOptions(allValueSets, TRIAL_SEARCH_VALUESETS),
        [BIOMARKER]: formatBiomarkerOptions(biomarkers),
      };
    });
  },
  {
    condition: function* () {
      const dropdowns = yield select(
        (state: { trialSearch: { dropdowns: Record<string, SelectOption[]> } }) => state.trialSearch.dropdowns,
      );

      return !hasLoadedDropdowns(dropdowns);
    },
  },
);

export default [
  takeEvery(getTrialMatches.actionType, getTrialMatches.asyncSaga),
  takeEvery(loadDropdowns.actionType, loadDropdowns.asyncSaga),
];
